import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

const alignCenterValues = ['H', 'BOTH'];
const justifyCenterValues = ['V', 'BOTH'];

const Column = ({ children, center='', className='', name='', style={} }) => {
  let fullClassName = classNames('flex-col', {
    'align-center': _.includes(alignCenterValues, center.toUpperCase()),
    'justify-center': _.includes(justifyCenterValues, center.toUpperCase())
  });

  if (className) {
    fullClassName += ` ${className}`;
  }

  return (
    <div className={fullClassName} name={name} data-name="Column" style={style}>{children}</div>
  );
};

Column.propTypes = {
  center: PropTypes.oneOf(['H', 'V', 'BOTH']),
  className: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.object
};

export default Column;
